// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "ad_promotion_check".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { adPromotionCheckVerdictValues } from '@borradh-workspace/labels';
/** Response atom for the "ad_promotion_check" table (1:1 with a DB row, on the wire). */
export const adPromotionCheckAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    metaAdId: z.string(),
    verdict: z.enum(adPromotionCheckVerdictValues),
    issues: z.unknown(),
    relatedOfferIds: z.array(z.string()),
    contradictedOfferIds: z.array(z.string()),
    summary: z.string(),
    inputsHash: z.string(),
    recheckAt: z.string().datetime().nullable(),
    model: z.string().nullable(),
    importAttemptedAt: z.string().datetime().nullable(),
    importOutcome: z.unknown().nullable(),
    checkedAt: z.string().datetime(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=adPromotionCheck.js.map